import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import ProductTypesTopBar from './includes/ProductTypesTable/ProductTypesTopBar'
import ProductTypesTable from './includes/ProductTypesTable/ProductTypesTable'
import { toast } from 'react-toastify';
// import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import useQuery from 'utlis/CustomHooks/useQueryHook'
import { } from 'utlis/AppMessages/AppMessages'
import { deleteProductTypes, getProductTypes } from 'utlis/Apis/ProductTypes_API'
import { ERROR_WHILE_FETCHING_PRODUCTTYPES } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { PRODUCTTYPE_DELETED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_DELETING_PRODUCTTYPE } from 'utlis/AppMessages/AppMessages'
import { CONFIRMATION_BEFORE_DELETING_PRODUCTTYPE } from 'utlis/AppMessages/AppMessages'
// import Pagination from 'components/CommonComponents/Pagination/Pagination'

function ProductTypes(props) {
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

    const [prodcutTypes, setProdcutTypes] = useState([])
    const [loading, setLoading] = useState(true)

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)

    const [column__AttributeName, setColumn__AttributeName] = useState(true)
    const [column__Status, setColumn__Status] = useState(true)
    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)
    // const [paginationLinks, setPaginationLinks] = useState([])
    // const [searchQuery, setSearchQuery] = useState("")

    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    useEffect(() => {
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setSectionLoadingVisible(true)

        getProductTypes(props.currentUser.userToken, URLParams).then(res => {
            setSectionLoadingVisible(false)
            setLoading(false)

            const resData = res.data

            window.scrollTo(0, 0)
            if (resData && resData.success) {
                // setPaginationLinks(resData.links)
                setProdcutTypes(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();

                toast.error(ERROR_WHILE_FETCHING_PRODUCTTYPES, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getProductTypes `, err.message)

            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [keyword, page, props])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);
    };

    const handleDelete = (ev, id) => {
        ev.preventDefault()

        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_PRODUCTTYPE)

        if (confirmation) {
            setSectionLoadingVisible(true)

            deleteProductTypes(props.currentUser.userToken, id).then(res => {

                setSectionLoadingVisible(false)

                const deletedData = res.data
                if (deletedData.success) {
                    const filtersCustomerGroupsList = prodcutTypes.filter(item => item.attribute_id !== id)
                    console.log(filtersCustomerGroupsList)
                    setProdcutTypes(filtersCustomerGroupsList)

                    toast.dismiss();
                    toast.success(PRODUCTTYPE_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_PRODUCTTYPE, res)
                    toast.dismiss();

                    toast.error(ERROR_WHILE_DELETING_PRODUCTTYPE, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteCustomerGroup `, err.message)

                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }

    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        setSectionLoadingVisible(true)
        if (searchQueryValue && searchQueryValue.length) {
            // setSearchQuery(searchQueryValue)
            props.history.push(`/settings/product-types?keyword=${searchQueryValue}&page=1`)
        }
        if (!searchQueryValue) {
            // setSearchQuery("")
            props.history.push(`/settings/product-types?page=1`)
        }
    }, 500)

    return (
        <section id="app-prodcutTypes" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-prodcutTypes">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Product Types</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <ProductTypesTopBar
                                        column__AttributeName={column__AttributeName}
                                        column__Status={column__Status}
                                        setColumn__AttributeName={bool => setColumn__AttributeName(bool)}
                                        setColumn__Status={bool => setColumn__Status(bool)}
                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table prodcutTypes-table">
                                    <ProductTypesTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}
                                        column__AttributeName={column__AttributeName}
                                        column__Status={column__Status}

                                        loadingCount={loadingCount}
                                        loading={loading}
                                        prodcutTypes={prodcutTypes}
                                        handleDelete={(ev, groupId) => handleDelete(ev, groupId)}
                                    />
                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                {/* <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/settings/product-types"}
                                    paginationLinks={paginationLinks}
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(ProductTypes)